@file:kotlin.js.JsExport
/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */


package com.narbase.letsgo.web.routing.domain.admin.login

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.admin.AdminDto
import com.narbase.letsgo.web.dto.admin.DynamicRoleDto


object GetAdminProfileDetailsEndpoint : EndPoint<GetAdminProfileDetailsEndpoint.Request, GetAdminProfileDetailsEndpoint.Response>() {
    class Request

    class Response(
            val admin: AdminDto,
            val roles: Array<DynamicRoleDto>
    )
}

